import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import { AuthStore } from '../store';

export const authGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (!authStore.user()) {
    await authStore.getSession();
  }

  if (authStore.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login-page']);
};
